<template>
  <button @click="handleClick" :class="btnClass" :disabled="isDisabled">
    <slot name="icon"></slot>
    {{ value }}
  </button>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  props: {
    color: {
      type: String
    },
    value: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    icon: {
      type: String
    },
    fieldId: {
      type: String
    },
    direction: {
      type: String,
      default: 'forward'
    },
    logAction: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['steps']),
    currentStepNum() {
      // If ROOT path, then we're at step 0, otherwise find the current step
      // based on path
      return this.path === '/' ? 0 : this.steps.pathing.indexOf(this.path);
    },
    nextStep() {
      return this.steps.pathing[this.currentStepNum + 1];
    },
    prevStep() {
      return this.steps.pathing[this.currentStepNum - 1];
    },
    btnClass() {
      const baseClass = 'mdl-button mdl-js-button';
      let options = '';
      switch (this.color) {
        case 'primary':
          options = 'mdl-button--raised mdl-button--primary';
          break;
        default:
          options = 'mdl-button--raised';
      }
      return `${baseClass} ${options}`;
    }
  },
  data() {
    return {
      // For calculating next step
      path: this.$route.path.split('?')[0]
    };
  },
  methods: {
    ...mapActions(['setNextToReview']),
    handleClick() {
      this.emitSpecialActions(this.logAction);

      // If going back from review page
      if (this.steps.nextReview) {
        this.$router.push({path: '/review'});
        this.setNextToReview(false);
        // Normal navigation
      } else if (this.direction === 'forward') {
        this.$router.push({path: this.steps.pathing[this.steps.next]});
      } else {
        this.$router.push({path: this.steps.pathing[this.steps.previous]});
      }
    },
    emitSpecialActions(action) {
      switch (action) {
        case 'start-proxy':
          this.$events.$emit('log-voter-action', 'Start Proxy');
          break;
        case 'abstain-modal':
          this.$emit('click-abstain-modal');
          break;
        case 'next-question':
          this.$emit('go-next-question');
          break;
        case 'option-modal':
          this.$emit('click-option-modal');
          break;
        case 'review-modal':
          this.$emit('click-review-modal');
          break;
      }
    }
  },
  created() {
    // Listen for the call to determine if this button should be focused
    this.$events.$on('go-input', input => {
      if (input === this.fieldId) {
        this.$el.focus();
      }
    });
  },
  beforeDestroy() {
    this.$events.$off('go-input', input => {
      if (input === this.fieldId) {
        this.$el.focus();
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Button.vue